// assets
import { CalendarOutlined, ShopOutlined, ShoppingOutlined, BarChartOutlined } from '@ant-design/icons';
import { reactLocalStorage } from 'reactjs-localstorage';

// icons
const icons = {
  CalendarOutlined,
  ShopOutlined,
  ShoppingOutlined,
  BarChartOutlined
};

// ==============================|| MENU ITEMS - EXTRA PAGES ||============================== //

let getUserInfo = reactLocalStorage.get('user_info')
getUserInfo = getUserInfo ? JSON.parse(getUserInfo) : null

const pagesReport = {
  id: 'pages-report',
  title: 'Report',
  type: 'group',
  children: [
    {
        id: 'report',
        title: 'Reports',
        type: 'item',
        url: '/report',
        icon: icons.BarChartOutlined,
        breadcrumbs: true
    },
  ]
};

export default pagesReport;
